"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigContext = exports.defaultConfig = void 0;
exports.withConfig = withConfig;
const React = __importStar(require("react"));
exports.defaultConfig = {
    api: {
        uri: {
            host: 'anypoint.mulesoft.com',
            pathname: '/exchange',
            protocol: 'https'
        }
    },
    platform: {
        uri: {
            host: 'anypoint.mulesoft.com',
            protocol: 'https'
        }
    },
    featureFlags: {},
    env: 'production',
    assetDeleteDaysLimit: 7,
    defaultPageName: 'home'
};
/**
 * Exchange global configuration used by all UI components. Contains information like API URI, feature flags, services and their URLs and much more (and growing).
 *
 * @category Contexts
 */
exports.ConfigContext = React.createContext(exports.defaultConfig);
exports.ConfigContext.displayName = 'ConfigContext';
/**
 * @ignore
 */
function withConfig(Component) {
    return function ConfigComponent(props) {
        return (React.createElement(exports.ConfigContext.Consumer, null, (config) => React.createElement(Component, Object.assign({}, props, { config: config }))));
    };
}
